
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, ServiceResponseModule } from '@sdbn/common';

import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { TransportExternalInformationsComponent } from './component/transport-external-informations.component';

@NgModule({
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    CommonUIModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule
  ],
  declarations: [
    TransportExternalInformationsComponent
  ],
  exports: [
    TransportExternalInformationsComponent
  ]
})
export class TransportExternalInformationsModule { }
